import React, { useState } from 'react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import { cloneDemo } from 'providers/mutations'
import RequestDialog from 'components/dialogs/RequestDialog'
import { useNavigateTo } from 'infrastructure/routing'

export default function CloneDemo({
  demoID,
  schoolID,
}: {
  readonly demoID: number
  readonly schoolID: number
}) {
  const navigate = useNavigateTo()
  const [cloningDemo, setCloningDemo] = useState(false)
  const [cloneID, setCloneID] = useState(-1)
  const [errorMessage, setErrorMessage] = useState('')

  const cloneDemoOnClick = async () => {
    // open dialog when button is clicked
    setCloningDemo(true)

    const res = await cloneDemo(demoID, schoolID)

    if (res.errors) {
      setCloningDemo(false)
      setErrorMessage('There was an error cloning this demo.')
    } else {
      setCloneID(res.data)
      errorMessage !== '' && setErrorMessage('')
    }
  }
  const navigateToClone = () => {
    navigate(`/demos/${cloneID}/show`)

    // close dialog
    setCloningDemo(false)
  }

  return (
    <>
      <Button variant="outlined" onClick={cloneDemoOnClick}>
        Clone Demo
      </Button>

      {errorMessage && (
        <Alert
          severity="error"
          onClose={() => {
            setErrorMessage('')
          }}
        >
          {errorMessage}
        </Alert>
      )}

      <RequestDialog
        open={cloningDemo}
        title="Cloning complete! Take me to my new demo."
        content={[]}
        submitRequest={navigateToClone}
        onClose={() => setCloningDemo(false)}
      />
    </>
  )
}
